/** 通用字段-中文 */
export const common_cn = {
  // 按钮
  new: '新建',
  copy: '复制',
  remove: '移除',
  import: '导入',
  export: '导出',
  open: '开',
  reset: '重置',
  search: '搜索',
  unfold: '展开',
  fold: '收起',
  view: '查看',
  clear: '清空',
  detail: '详情',
  delete: '删除',
  confirm: '确认',
  cancel: '取消',
  submit: '提交',
  edit: '编辑',
  add: '添加',
  operation: '操作',
  back: '返回上一页',
  addNow: '立即新增',
  amend: '修改',
  save: '保存',
  publish: '发布',
  yes: '是',
  no: '否',
  ok: '好的',
  customized_list: '自定义列表',
  previous: '上一页',
  next: '下一页',
  view_more: '查看更多',
  close_more: '关闭更多',

  // 标语
  pleaseInput: '请输入',
  pleaseSelect: '请选择',
  pleaseUpload: '请选择',
  to: '至',
  startTime: '开始时间',
  endTime: '结束时间',
  total: '总计',
  tips: '提示',
  failed: '失败',
  loading: '加载中',
  onlyLookAtOneself: '只看自己',
  all: '全部',
  isRequired: '必填',

  // header
  balance: '剩余点数',
  hotLine: '客服电话',
  email: '客服邮箱',
  qa: '常见Q&A',
  manual: '操作手册',
  logOut: '退出登录',
  logIn: '立即登录',
  cn: '中文',
  en: '英文',

  // 星期日期
  week1: '星期一',
  week2: '星期二',
  week3: '星期三',
  week4: '星期四',
  week5: '星期五',
  week6: '星期六',
  week7: '星期日',
  yearof: '{0}年',

  // 操作历史
  history: '操作历史',
  code: '状态代码',
  description: '状态说明',
  user: '操作人',
  modify_time: '更新时间',
  hblno: 'HBL No.',
  input_guide: '字段填写说明',
  field: '字段说明',
  m_c_o: '是否必填',
  max_length: '最大字符数',
  close: '关闭',
  sure: '确定',
  back_check: '返回修改',
  download: '下载模板',
  fail: '失败',
  warning: '提醒',
  succeed: '成功',
  submit_succeed: '提交成功',
  opt_failed: '操作失败',
  error_msg: '哎呀，接口异常，请联系客服',

  // 删除提示语
  delete_confirm: '是否确认删除?',
  // 提交提示语
  submit_confirm: '是否确认提交?',
  // 取消提示语
  cancel_confirm: '是否确认取消?',
  // 导出提示语
  exportSucceeded: '导出成功！请点击右上角下载图标查看导出记录',
  exportFailedExceeds:
    '导出失败！最多只支持60天内数据的导出，请调整时间范围后重试',
  exportFailed: '导出失败！接口异常，请联系客服处理',
  // 导入提示语
  importSucceeded: '导入成功，请在列表页查看导入数据！',
  importFailed: '导入失败，请查看文件后重试！',
  file_error: '文件格式错误',
  parse_error: '解析失败，请点击右上角上传/下载按钮查看失败原因',
  // 空状态
  no_data: '对不起，暂无数据',

  required: '此项为必填',
  format_error: '格式错误',
  upload: '上传',
  // 上传图片
  error1: '上传文件大小不能超过10MB',
  error2: '图片格式为JPG或PNG',
  error3: '请上传图片进行提交',
  supplement_information: '请补充箱货信息',
  must_usa_port: '请选择美国的港口',
  not_usa_port: '请选择非美国的港口',
  emailIsWrongFormat: '请输入正确的邮箱地址',
  integermustmorethan0: '请输入大于0的整数',
  cusServiceDontExist: '客服信息不存在',
  cardInfoDontExist: '运价信息不存在',
  sureLogout: '是否确定退出登录？',
  reLoginDesc:
    '此账号已在另一地点登录，您已被迫下线。如果此操作您不知情，请修改密码以确保账号安全',
  keywordNeed: '请输入搜索关键词',
}

/** 通用字段-英文 */
export const common_en = {
  // 按钮
  new: 'New',
  copy: 'Copy',
  remove: 'Remove',
  import: 'Import',
  export: 'Export',
  open: 'on',
  reset: 'Reset',
  search: 'Search',
  unfold: 'Unfold',
  fold: 'Fold',
  view: 'View',
  clear: 'Clear',
  detail: 'Detail',
  delete: 'Delete',
  confirm: 'Confirm',
  submit: 'Submit',
  edit: 'Edit',
  cancel: 'Cancel',
  add: 'Add',
  operation: 'Operation',
  back: 'Back',
  addNow: 'Add it now',
  amend: 'Amend',
  save: 'Save',
  publish: 'Publish',
  yes: 'Yes',
  no: 'No',
  ok: 'OK',
  customized_list: 'Customized List',
  previous: 'Previous',
  next: 'Next',
  view_more: 'View More',
  close_more: 'Close More',

  // 标语
  pleaseInput: 'Please enter',
  pleaseSelect: 'Please select',
  pleaseUpload: 'Please upload',
  to: 'To',
  startTime: 'Start Time',
  endTime: 'End Time',
  total: 'Total',
  tips: 'Tips',
  failed: 'Failed',
  loading: 'Loading',
  onlyLookAtOneself: 'My Transactions Only',
  all: 'all',
  isRequired: 'is required',

  // header
  balance: 'Balance',
  hotLine: 'Hot Line',
  email: 'E-mail',
  qa: 'FQ&A',
  manual: 'Manual',
  logOut: 'Log out',
  logIn: 'Log in',
  cn: 'CN',
  en: 'EN',

  // 星期日期
  week1: 'Monday',
  week2: 'Tuesday',
  week3: 'Wednesday',
  week4: 'Thursday',
  week5: 'Friday',
  week6: 'Saturday',
  week7: 'Sunday',
  yearof: 'Year of {0}',

  //
  // 操作历史
  history: 'History',
  code: 'Code',
  description: 'Description',
  user: 'User',
  modify_time: 'Modify Time',
  hblno: 'HBL No.',

  input_guide: 'Input Guide',
  field: 'Field',
  m_c_o: 'M/C/O',
  max_length: 'Max. Length',
  close: 'Close',
  sure: 'Sure',
  back_check: 'Back',
  download: 'Download Template',
  fail: 'Fail',
  warning: 'Warning',
  succeed: 'Succeed',
  submit_succeed: 'Submitted successfully',
  opt_failed: 'Operation Failed',
  error_msg:
    'Oops, the interface is abnormal. Please contact customer service.',

  // 删除提示语
  delete_confirm: 'Are you sure to delete?',
  // 提交提示语
  submit_confirm: 'Are you sure to submit?',
  // 取消提示语
  cancel_confirm: 'Are you sure to cancel?',
  // 导出提示语
  exportSucceeded:
    'Succeeded! Please click the download icon in the upper right corner to view the export record',
  exportFailedExceeds:
    'Failed! Only data within 60 days can be exported. Please adjust the time range and try again',
  exportFailed: 'Failed! Please contact customer service for support',
  // 导入提示语
  importSucceeded:
    'Import succeeded. Please view the imported data in the list page!',
  importFailed: 'Import failed. Please check the file and try again!',
  file_error: 'File format error',
  parse_error:
    'Failed, please check the reason via click the import/export botton on the right header',
  // 空状态
  no_data: 'Sorry, no data available',

  required: 'Required',
  format_error: 'Format error',
  upload: 'Upload',
  // 上传图片
  error1: 'Please upload file less than 10 MB.',
  error2: 'Please upload images in JPG/PNG.',
  error3: 'Please upload picture.',
  supplement_information: 'Please supplement the box cargo information',
  must_usa_port: 'Please select a port in the United States',
  not_usa_port: 'Please select a port outside the United States',
  emailIsWrongFormat: 'Please enter a valid email.',
  integermustmorethan0: 'Please enter a positive integer.',
  cusServiceDontExist: 'Customer service information does not exist',
  cardInfoDontExist: 'Rate information does not exist',
  sureLogout: 'Are you sure to log out?',
  reLoginDesc:
    'This account has been logged in from another location, and you have been forced to log out. If you are unaware of this operation, please change your password to ensure the security of your account.',
  keywordNeed: 'Please enter your search keyword',
}
